/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query HatchQuery($uid: String!) {
    prismic {
      hatch(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_HatchBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_HatchBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_HatchBodyLeftslidingnavcontent {
          type
  label
  fields {
    content_subtitle
    content_title
    copy
    heading
    heading_color
    quote_author_details
    quote
    quote_author_image
    quote_author_name
    quote_author_details_2
    quote_2
    quote_author_image_2
    quote_author_name_2
    quote_author_details_3
    quote_3
    quote_author_image_3
    quote_author_name_3
    quote_author_details_4
    quote_4
    quote_author_image_4
    quote_author_name_4
    subheading
    subheading_color
  }
  primary {
    background_color
    background_image
    text_color
  }
        },
        ... on PRISMIC_HatchBodyListalternatingv2 {
          type
            label
            fields {
              list_alt_image
              list_alt_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_alt_link_text
              list_alt_text
              list_alt_title
              list_link_color
              list_text_color
              list_title_color
            }
            primary {
              background_color
              heading
              subheading
              background_image
              heading_color
              subheading_color
              text_color
            }
        },
        ... on PRISMIC_HatchBodyCardsv2 {
          type
            label
            fields {
              image
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              text
              text_color
              title1
              title_color
            }
            primary {
              background_color
              columns
              content_alignment
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              heading_color
              subheading
              subheading_color
              text_color
              background_image
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Hatch = ({ data, location }) =>
  data.prismic.hatch ? (
    <MainLayout location={location} layout='hatch'>
    <Helmet>
      <title>{(data.prismic.hatch.title[0] && data.prismic.hatch.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.hatch.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.hatch.path : 'https://www.digitalocean.com' + data.prismic.hatch.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.hatch.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.hatch.title[0] ? data.prismic.hatch.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.hatch.description ? data.prismic.hatch.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.hatch.open_graph_image ? data.prismic.hatch.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.hatch.description ? data.prismic.hatch.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.hatch.title[0] ? data.prismic.hatch.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.hatch.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.hatch.path : 'https://www.digitalocean.com' + data.prismic.hatch.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.hatch.open_graph_image ? data.prismic.hatch.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.hatch.body} />
    </MainLayout>
  ) : null;

Hatch.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Hatch;
